import React, { useState, useEffect } from "react";
import "react-quill-new/dist/quill.snow.css";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadIcon from "../../Assets/img/upload.png";
import { useNavigate } from "react-router-dom";
import API from "../Service/Baseservice";
import { useLocation } from "react-router-dom";
import TestimonialVideoPreview from "./TestimonialVideoPreview";

const TestimonialVideoAdd = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const [allVideos, setAllVideos] = useState([]);
    const languageIdFromURL = Number(params.get("lang")) || 1;
    const testimonialIdFromURL = Number(params.get("testimonial_id")) || 1;
    const [showPreviewTestimonialVideo, setShowPreviewTestimonialVideo] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [languageId, setLanguageId] = useState(languageIdFromURL);
    const [name, setName] = useState("");
    const [professional, setProfessional] = useState("");
    const [description, setDescription] = useState("");
    const [videoFile, setVideoFile] = useState(null);
    const [videoUrl, setVideoUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });
    const showPopup = (title, message, type = "error") => {
        setPopup({
            show: true,
            title,
            message,
            type,
        });
    };

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || div.innerText || "").length;
    };

    const handleVideoUpload = (e) => {
        console.log("onChange fired");
        const file = e.target.files[0];
        if (!file) return;

        setVideoFile(file);

        convertToBase64(file)
            .then((base64) => {
                const payload = {
                    name: file.name,
                    video: [
                        {
                            base64: base64,
                            type: file.type,
                            size: 20000000
                        }
                    ]
                };

                setLoading(true);

                API.post("/videoUpload/add", payload)
                    .then((res) => {
                        setLoading(false);

                        const uploadedUrl = res.data.video_url || res.data.url;

                        if (uploadedUrl) {
                            setVideoUrl(uploadedUrl);
                            showPopup("Uploaded", "Video uploaded successfully!", "success");
                        } else {
                            showPopup("Upload Failed", "Video upload failed.", "error");
                        }

                    })
                    .catch(() => {
                        setLoading(false);
                        showPopup("Error", "Error uploading video.", "error");
                    });
            })
            .catch(() => {
                showPopup("Error", "Cannot convert video to Base64.", "error");
            });
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleSave = () => {
        if (!videoUrl || !name || !professional || !description) {
            showPopup("Missing Fields", "Please fill all required fields and upload a video!", "error");
            return;
        }

        const payload = {
            language_id: languageId,
            testimonial_id: testimonialIdFromURL,
            videos: videoUrl,
            name,
            professional,
            description,
            status: "active",
            active: 1,
            createdBy: 1,
            updatedBy: 1
        };

        API.post("/add_videotestimonials/add", payload)
            .then((res) => {
                if (res.data.success) {
                    showPopup("Success", "Video testimonial added successfully!", "success");
                } else {
                    showPopup("Failed", "Could not save testimonial.", "error");
                }
            })
            .catch(() => {
                showPopup("Error", "Error saving testimonial.", "error");
            });
    };

    useEffect(() => {
        if (!testimonialIdFromURL) return;

        Promise.all([
            API.post("testimoniallistview/condition", {
                language_id: 1,
                home_id: 2,
                testimonial_id: testimonialIdFromURL
            }),
            API.post("testimoniallistview/condition", {
                language_id: 2,
                home_id: 4,
                testimonial_id: testimonialIdFromURL
            })
        ])
            .then(([res1, res2]) => {
                const videos1 = res1.data?.data?.video_testimonials || [];
                const videos2 = res2.data?.data?.video_testimonials || [];
                setAllVideos([...videos1, ...videos2]);
            })
            .catch(err => console.error(err));
    }, [testimonialIdFromURL]);


    const handlePreview = () => {
        if (!name.trim()) {
            return showPopup("Required", "Name is required for preview!", "info");
        }

        if (!professional.trim()) {
            return showPopup("Required", "Professional field is required for preview!", "info");
        }

        if (!description.trim()) {
            return showPopup("Required", "Description is required for preview!", "info");
        }

        if (!videoUrl) {
            return showPopup("Required", "Please upload a video before preview!", "info");
        }


        const previewVideo = {
            videotestimonial_id: "preview",
            videos: videoUrl,
            name,
            professional,
            description,
        };

        const finalVideos = [
            previewVideo,
            ...allVideos
        ];

        setPreviewData({
            videoTestimonials: finalVideos
        });

        setShowPreviewTestimonialVideo(true);
    };



    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2>Add Videos Testimonials</h2>

                <div className="button-group">
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleSave}>
                        Save
                    </button>

                    <button
                        onClick={() => navigate(`/testimonialedit/${testimonialIdFromURL || 1}?lang=${languageId}`)}
                        className="language-cancel-btn"
                    >
                        Back
                    </button>
                </div>
            </div>

            <div className="service-container">
                {/* Left Section */}
                <div className="left-form">
                    <div className="upload-section">
                        <label>
                            Upload Video <span className="required">*</span>
                        </label>

                        <div className="service-upload-box">
                            {!videoUrl ? (
                                <>
                                    <img src={UploadIcon} className="upload-icon" />
                                    <p>Click to upload</p>
                                </>
                            ) : (
                                <video width="100%" controls>
                                    <source src={videoUrl} type="video/mp4" />
                                </video>
                            )}

                            <input type="file" accept="video/*" onChange={handleVideoUpload} />
                        </div>

                        {loading && <p>Uploading...</p>}
                    </div>
                </div>

                {/* Right Section */}
                <div className="testimonial-right-section">
                    <div className="form-group">
                        <label>Name <span className="required">*</span></label>
                        <input
                            type="text"
                            placeholder="Enter your text here..."
                            maxLength={70}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Professional<span className="required">*</span></label>
                        <input
                            type="text"
                            placeholder="Enter your text here..."
                            maxLength={150}
                            value={professional}
                            onChange={(e) => setProfessional(e.target.value)}
                        />
                    </div>
                    <div className="news-form-group editor-small">
                        <label className="news-description-label">
                            <span className="label-text">Description<span className="required">*</span></span>

                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {getPlainTextLength(description)}/4000
                                </span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                if (getPlainTextLength(data) <= 4000) {
                                    setDescription(data);
                                }
                            }}
                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                            className="description1-editor"
                        />
                    </div>
                </div>
            </div>
            {/* Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/homepage");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showPreviewTestimonialVideo && (
                <TestimonialVideoPreview
                    previewService={previewData}
                    setShowPreviewTestimonialVideo={setShowPreviewTestimonialVideo}
                />
            )}
        </div>
    );
};

export default TestimonialVideoAdd;
